<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M8.999999940395355,11.8571C8.999999940395355,11.8571,8.999999940395355,16,8.999999940395355,16C8.999999940395355,16,6.999999940395355,16,6.999999940395355,16C6.999999940395355,16,6.999999940395355,11.8571,6.999999940395355,11.8571C6.999999940395355,11.8571,0.9999999403953552,13,0.9999999403953552,13C0.9999999403953552,13,4.884819940395355,8.56021,4.884819940395355,8.56021C4.884819940395355,8.56021,2.9999999403953552,9,2.9999999403953552,9C2.9999999403953552,9,6.069309940395355,4.70297,6.069309940395355,4.70297C6.069309940395355,4.70297,4.999999940395355,5,4.999999940395355,5C4.999999940395355,5,7.999999940395355,0,7.999999940395355,0C7.999999940395355,0,10.999999940395355,5,10.999999940395355,5C10.999999940395355,5,9.930689940395355,4.70297,9.930689940395355,4.70297C9.930689940395355,4.70297,12.999999940395355,9,12.999999940395355,9C12.999999940395355,9,11.115199940395355,8.56021,11.115199940395355,8.56021C11.115199940395355,8.56021,14.999999940395355,13,14.999999940395355,13C14.999999940395355,13,8.999999940395355,11.8571,8.999999940395355,11.8571C8.999999940395355,11.8571,8.999999940395355,11.8571,8.999999940395355,11.8571Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'Tree',
} as DefineComponent
</script>
